<!-- Begin page -->
<div id="layout-wrapper">

  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <a href="/dashboard/administrator" class="logo logo-dark">
                                <span class="logo-sm">
                                    <img src="assets/img/certikap_logo_solo.png" alt="CertiKap">
                                </span>
            <span class="logo-lg">
                                    <img src="assets/img/logo-alaya.png" alt="" height="17">
                                </span>
          </a>

          <a href="/dashboard/administrator" class="logo logo-light">
                                <span class="logo-sm">
                                    <img src="assets/img/certikap_logo_solo.png" alt="CertiKap">
                                </span>
            <span class="logo-lg">
                                    <img src="assets/img/logo-alaya.png" alt="" height="19">
                                </span>
          </a>
        </div>

        <button type="button" class="btn btn-sm px-3 font-size-16 header-item waves-effect" id="vertical-menu-btn"
                [attr.aria-label]="'header.toggleMenu' | translate">
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <div class="d-flex align-items-center ml-3">
          <img src="assets/img/pasteur.png" alt="Institut Pasteur" height="64">
        </div>

      </div>
      <span class="badge badge-danger" *ngIf="takeInHand && takeInHand === 'yes'">
        <h4 style="color: #ffffff;"><span class="bx bx-info-circle"></span> {{'header.impersonationActive' | translate}}</h4>
        <button type="button" class="btn btn-primary waves-effect waves-light" (click)="returner(admin_login)">
            {{'header.returnPreviousAccount' | translate}}
          </button>
      </span>
      <div class="d-flex align-items-center">

        <app-language-selector></app-language-selector>

        <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item waves-effect" id="page-header-user-dropdown"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img class="rounded-circle header-profile-user" src="{{single_user.photo}}"
                 [alt]="'header.profileAvatar' | translate">
            <span class="d-none d-xl-inline-block ml-1">{{single_user.name}}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-right">
            <!-- item-->
            <a class="dropdown-item" href="/dashboard/administrator/profile"><i class="bx bx-user font-size-16 align-middle mr-1"></i> {{'header.myProfile' | translate}}</a>
            <a class="dropdown-item text-danger" (click)="logout_user()"><i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i> {{'header.logout' | translate}}</a>
          </div>
        </div>
      </div>
    </div>
  </header>
